// User IDs that are treated as test accounts.
// Their bookings are hidden from admin views, excluded from revenue,
// and they are not required to pay a deposit when booking.
export const TEST_ACCOUNT_USER_IDS: ReadonlySet<string> = new Set([
  "074bda81-6b3a-4c14-a47f-05d544e565bc", // ahmed@fraichespecs.com
]);

export const isTestAccount = (userId?: string | null): boolean =>
  !!userId && TEST_ACCOUNT_USER_IDS.has(userId);
